export enum RouteNameNearbyEnum {
  Next = 'next',
  Previous = 'previous',
}
